import { Autocomplete as MuiAutocomplete, Paper, TextField } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Autocomplete = styled(MuiAutocomplete)`
  ${({ theme }) => css`
    & .MuiOutlinedInput-root {
      height: 48px;
      border-radius: 24px;
      font-size: 1rem;

      & .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${theme.colors.gray.dark};
      }

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.colors.primary};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: 2px solid ${theme.colors.primary} !important;
      }
    }

    & .MuiInputBase-input {
      color: ${theme.colors.gray.dark};
      padding-top: 8px !important;
      padding-left: 8px;
      font-size: 16px;

      &::placeholder {
        color: ${theme.colors.gray.dark};
        opacity: 0.5;
        font-size: 16px;
      }
    }
  `}
`

export const Input = styled(TextField)`
  .MuiAutocomplete-endAdornment {
    margin-right: 0 !important;
    padding: 0 !important;
  }

  .MuiAutocomplete-clearIndicator {
    display: none !important;
  }

  .MuiInputAdornment-root.MuiInputAdornment-positionStart {
    margin-left: 6px;
    margin-right: 6px;
    color: ${({ theme }) => theme.colors.gray.dark};
  }

  .MuiInputLabel-root {
    color: ${({ theme }) => theme.colors.gray.dark};
    opacity: 0.5;
    font-size: 16px;
  }

  .MuiInputLabel-root:not(.MuiInputLabel-shrink) {
    transform: translate(40px, 13px) scale(1);
  }

  .MuiInputLabel-root.MuiInputLabel-shrink {
    transform: translate(29px, -8px) scale(0.75);
    transform-origin: top left;
    color: ${({ theme }) => theme.colors.gray.dark};
    opacity: 1;
  }

  .Mui-focused .MuiInputLabel-root {
    color: ${({ theme }) => theme.colors.gray.dark};
  }

  .MuiOutlinedInput-notchedOutline legend {
    margin-left: 12px !important;
  }
`

export const MenuPaper = styled(Paper)`
  ${({ theme }) => css`
    border-radius: 4px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1) !important;
    margin-top: 0px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    max-height: 228px !important;
    overflow-y: auto !important;

    .MuiAutocomplete-listbox {
      max-height: 228px !important;
      overflow-y: auto !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;

      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.background.hover};
        border-radius: 8px;
        transition: background-color 0.3s ease;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.colors.background.hover};
      }

      scrollbar-width: thin;
      scrollbar-color: ${theme.colors.background.hover} transparent;
    }

    .MuiAutocomplete-option {
      min-height: 48 !important;
      padding: 12px 16px !important;

      &:hover {
        background-color: ${theme.colors.background.hover} !important;
      }

      &[aria-selected='true'] {
        background-color: ${theme.colors.background.hover} !important;
      }

      &[data-focus='true'] {
        background-color: ${theme.colors.background.hover} !important;
      }
    }

    && .MuiAutocomplete-option:hover,
    && .MuiAutocomplete-option:focus,
    && .MuiAutocomplete-option:focus-visible,
    && .MuiAutocomplete-option.Mui-focused,
    && .MuiAutocomplete-option.Mui-focusVisible,
    && .MuiAutocomplete-option[data-focus='true'],
    && .MuiAutocomplete-option[aria-selected='true'] {
      background-color: ${theme.colors.background.hover} !important;
    }
  `}
`
